import { Node } from '@antv/x6';
import styles from './index.module.scss';
const VirtualRoot = ({ node }: { node: Node }) => {
  return <div className={styles.virtual_root_box}></div>;
};

export default VirtualRoot;
